import { render } from "./echartsBox.vue?vue&type=template&id=f2674bae&scoped=true"
import script from "./echartsBox.vue?vue&type=script&lang=js"
export * from "./echartsBox.vue?vue&type=script&lang=js"

import "./echartsBox.vue?vue&type=style&index=0&id=f2674bae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2674bae"]])

export default __exports__